// single.js
window.addEventListener('load', () => {
  const main = document.querySelector('main')
  if (!main || !main.classList.contains('single')) return

  // related ajax pagination (single)
  const wrapper = document.querySelector('.js-related')
  const list = document.querySelector('.js-related-list')
  const pager = document.querySelector('.js-related-pager')
  if (!wrapper || !list || !pager || !window.NA_RELATED) return

  // ▼ スクロール先
  const listAnchor = document.getElementById('list')
  const headerOffset = document.querySelector('header')?.offsetHeight || 0
  const scrollToList = () => {
    if (!listAnchor) return
    const y = listAnchor.getBoundingClientRect().top + window.scrollY - headerOffset - 8
    const prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    window.scrollTo({ top: y, behavior: prefersReduced ? 'auto' : 'smooth' })
    listAnchor.setAttribute('tabindex', '-1')
    listAnchor.focus?.()
  }

  // ajax_url は固定、nonce は後で更新するので let にして保持
  const { ajax_url, nonce } = window.NA_RELATED
  let currentNonce = nonce

  // dataset
  const postId = parseInt(wrapper.dataset.postId || '0', 10) || 0
  const tax = wrapper.dataset.tax || 'ingredients'
  const termIds = (wrapper.dataset.termIds || '').trim() // CSV

  let loading = false

  // nonce を再発行（403対策）
  const refreshRelatedNonce = () =>
    fetch(ajax_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: new URLSearchParams({ action: 'na_related_nonce' }),
    })
      .then((r) => r.json())
      .then((json) => {
        if (json?.success && json.data?.nonce) {
          currentNonce = json.data.nonce
          return true
        }
        return false
      })
      .catch(() => false)

  // 実コール（失敗→nonce更新→1回だけリトライ）
  const requestPage = (page, triedRefresh = false) =>
    fetch(ajax_url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: new URLSearchParams({
        action: 'na_related_recipes',
        nonce: currentNonce,
        page,
        post_id: postId,
        tax,
        term_ids: termIds,
      }),
    }).then(async (r) => {
      if (!r.ok && !triedRefresh) {
        const ok = await refreshRelatedNonce()
        if (ok) return requestPage(page, true)
      }
      return r.json()
    })

  const loadPage = (page) => {
    if (loading) return
    loading = true
    wrapper.classList.add('is-loading')

    return requestPage(page)
      .then((json) => {
        if (!json || !json.success) return
        list.innerHTML = json.data.items_html
        pager.innerHTML = json.data.pager_html

        // URLを ?relpage=N に更新（archive側の ?page と衝突させない）
        const url = new URL(location.href)
        url.searchParams.set('relpage', page)
        history.replaceState(null, '', url.toString())

        scrollToList()
      })
      .catch(() => {})
      .finally(() => {
        loading = false
        wrapper.classList.remove('is-loading')
      })
  }

  // ページャ委譲
  pager.addEventListener('click', (e) => {
    const el = e.target.closest('[data-page]')
    if (!el) return
    e.preventDefault()

    const page = parseInt(el.dataset.page || '1', 10)
    if (
      isNaN(page) ||
      page < 1 ||
      el.classList.contains('is-current') ||
      el.classList.contains('disabled')
    )
      return

    loadPage(page)
  })

  // 初回 ?relpage=N があればロード
  const initPage = parseInt(new URL(location.href).searchParams.get('relpage') || '1', 10)
  if (initPage > 1) loadPage(initPage)
})
